import axios                  from 'axios';
import Cookies                from 'universal-cookie';
import { disconnectCable }    from 'services/cable';
import authHeader             from 'services/auth-header';
import WalletPasscodeService  from 'services/wallet-passcode.service';

const API_URL = process.env.REACT_APP_API_ENDPOINT + 'doctors/';

class AuthService {
  login(email, password) {
    return axios
      .post(API_URL + 'login', {
        email,
        password
      })
      .then(response => {
        if (response.data.auth_token) {
          var userHash        = response.data;
          userHash.user_type  = 'doctor';
          localStorage.setItem('user', JSON.stringify(userHash));

          // Setting cookie for Old Dr Portal.
          const cookies = new Cookies();
          cookies.set('AuthSession', { 'token': 'Bearer ' + userHash.auth_token, 'user': userHash }, { path: '/' });
        }

        return response.data;
      });
  }

  logout() {
    disconnectCable();

    axios
    .delete(API_URL + 'logout', { headers: authHeader() })
    .then(response => {
      return response.data;
    });
    
    localStorage.removeItem('user');
    localStorage.removeItem('assistant');
    localStorage.removeItem('practice_location');
    WalletPasscodeService.clearUnlock();
    const cookies = new Cookies();
    cookies.remove('AuthSession', { path: '/' });
  }

  forgotPassword(parameters) {
    return axios
      .post(process.env.REACT_APP_API_ENDPOINT + 'doctors/password', parameters)
      .then(response => {
        return response.data;
      }
    );
  }

  getCurrentUser() {
    const cookies     = new Cookies();
    const cookieUser  = cookies.get('AuthSession');
    let localUser     = JSON.parse(localStorage.getItem('user'));

    if (!localUser) {
      localStorage.removeItem('assistant');
      localStorage.removeItem('practice_location');
    }

    if (!localUser && !!cookieUser) {
      let userHash = cookieUser.user;
      userHash.user_type  = 'doctor';
      localStorage.setItem('user', JSON.stringify(userHash));
      localUser = userHash;
    }

    return localUser;
  }

  getCurrentUserSentryParams() {
    var userParams          = { id: null, email: null, user_type: null };
    const userObject        = JSON.parse(localStorage.getItem('user'));
    const assistantObject   = JSON.parse(localStorage.getItem('assistant'));
    const locationObject    = JSON.parse(localStorage.getItem('practice_location'));

    if (userObject) {
      // Must keep as id and email, as this is tracked by sentry over different issues.
      userParams.id         = userObject.id;
      userParams.email      = userObject.email;
      userParams.user_name  = userObject?.name;
      userParams.user_type  = userObject.user_type;
    }

    if (assistantObject) {
      userParams.assistant_id           = assistantObject.id;
      userParams.assistant_email        = assistantObject.email;
      userParams.assistant_clinic_id    = assistantObject.clinic_id;
      userParams.assistant_clinic_name  = assistantObject.clinic_name;
    }

    if (locationObject) {
      userParams.practice_location_id   = locationObject.id;
      userParams.practice_location_name = locationObject.name;
    }

    return userParams;
  }

  getCurrentAssistant() {
    return JSON.parse(localStorage.getItem('assistant'));
  }

  getPracticeLocation() {
    return JSON.parse(localStorage.getItem('practice_location'));
  }

  getSocketInfo(){
    let currentUser = this.getCurrentUserSentryParams();
    let isClinic = currentUser.user_type === 'assistant';
    let isAssistant = currentUser?.assistant_id ? true : false;
    return {
      isClinic: isClinic,
      isAssistant: isAssistant,
      chanelId: isClinic ? currentUser?.assistant_clinic_id : currentUser.id
    }
  }
}

export default new AuthService();